import React from 'react';
import Layout from '../common/Layout';
import Sidebar from '../common/Sidebar';
import {useBreakpoint} from '../util/handleBreakpoints';

const LayoutSidebar = (props) => {
    const breakpoints = useBreakpoint();

    return <Layout
        style={
            {
                flexDirection: (breakpoints.md ? `column` : `row`)
            }
        }
    >
        <Sidebar
            style={
                {
                    order: (breakpoints.md ? 2 : 0),
                    // boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.065)',
                    // zIndex: 5,
                    position: 'relative'
                }
            }
            toggleTitleHide={props.sidebarToggleTitleHide}
            toggleTitleShow={props.sidebarToggleTitleShow}
            toggleMeta={props.sidebarToggleMeta}
            right={props.sidebarRight}
            compactVisibility={props.sidebarCompactVisibility}
        >
            {props.sidebarContent}
        </Sidebar>
        <Layout
            style={
                {
                    order: 1
                }
            }
            className="bg-white"
        >
            {props.children}
        </Layout>
    </Layout>
}

export default LayoutSidebar;
